import React, { useMemo } from 'react'
import Styles from './AttributeView.module.scss'
import { AssetType } from 'core/logic/asset/asset.types'
import Tag from 'components/Tag'
import { t, tDefault } from 'translate/i18n'
import { useDevelopmentError } from 'context/ErrorReporting'

export const KNOWN_ATTRIBUTES = ['Color', 'Size'] as const
export const NON_VISIBLE_ATTRIBUTES = ['Type', 'GTIN', 'Sku', 'Product Name']

/**
 * Shows the attribute information
 **/
export default function AttributeView({
  type = 'visual',
  ...attribute
}: AssetType['attributes'][number] & {
  type?: 'tag' | 'visual'
}) {
  const logDevError = useDevelopmentError()
  const view = useMemo(() => {
    switch (type) {
      case 'tag':
        const translated = tDefault(
          `components.attributeView.tags.${attribute.trait_type as 'Size'}`,
          ''
        )
        if (translated !== '')
          return (
            <Tag size='small' variant='outline'>
              {translated} {attribute.value}
            </Tag>
          )
        return undefined
      case 'visual':
        switch (attribute.trait_type as (typeof KNOWN_ATTRIBUTES)[number]) {
          case 'Color':
            return (
              <div
                style={{ backgroundColor: attribute.value }}
                className={Styles.color}
              />
            )
          case 'Size':
            return <span className={Styles.default}>{attribute.value}</span>
          default:
            if (!NON_VISIBLE_ATTRIBUTES.includes(attribute.trait_type))
              logDevError(
                `Attribute ${attribute.trait_type} not mapped to attribute view`,
                module
              )
            return undefined
        }
    }
  }, [attribute.trait_type, type])
  if (view)
    return <div className={`${Styles.root} ${Styles[type]}`}>{view}</div>
  else return null
}
